import UserGroupProfileItem from '../../../../../projects/groups/i-service/model/UserGroupProfileItem';

/**
 * * Модель ответа на получение детальной информации неймспейса
 */
export default class GetNamespaceByIdResponse  {
	/**
	 * * Получение номера рабочего пространства
	 */
	NamespaceId!: string;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Номер иконки
	 */
	IconId!: string;
	/**
	 * * Ссылка на иконку
	 */
	IconUrl!: string;
	/**
	 * * Номер цвета
	 */
	ColorId!: string;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Список администраторов рабочей области
	 */
	AdminList!: Array<UserGroupProfileItem>;
	/**
	 * * Список команды
	 */
	EmployeeList!: Array<UserGroupProfileItem>;
	constructor(obj?: Partial<GetNamespaceByIdResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
